var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":_vm.width,"height":_vm.calcHeight,"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":_vm.path,"fill":_vm.colour}})])}
var staticRenderFns = []

export { render, staticRenderFns }